// import { prop } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
// export const playerId = prop('playerId');

import { handleActions } from 'redux-actions';
import { identity } from 'ramda';
import { generateId } from '@/utils/helper';

export const INITIAL_STATE = generateId();


// eslint-disable-next-line import/prefer-default-export
export const playerId = identity;

export const reducer = handleActions(
  {},
  INITIAL_STATE,
);
